// extracted by mini-css-extract-plugin
module.exports = {"articleNumber":"deliveryNoteRows_articleNumber__1jXPJ","articleDescription":"deliveryNoteRows_articleDescription__3EgfT","cell":"deliveryNoteRows_cell__1mQ_F"};